module.exports = __webpack_public_path__ + "img/ivas.e125a76.jpg";